import React, { useState } from 'react';
import { pdfjs, Document, Page } from 'react-pdf';
import classnames from 'classnames';
import Loading from 'swag-client-common/components/info/loading';
import ChevronLeft from 'assets/svg/arrow-left-custom.svg';
import ChevronRight from 'assets/svg/arrow-right-custom.svg';
import ChevronLeftDisabled from 'assets/svg/arrow-left-custom-disabled.svg';
import ChevronRightDisabled from 'assets/svg/arrow-right-custom-disabled.svg';
import classes from './custom-pdf-viewer.scss';
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;
const CustomPdfViewer = ({
  file
}) => {
  const [pageNumber, setPageNumber] = useState(1);
  const [numPages, setNumPages] = useState(1);
  const onDocumentLoad = ({
    numPages
  }) => {
    setNumPages(numPages);
  };
  const goPrev = () => {
    setPageNumber(pageNum => pageNum - 1);
  };
  const goNext = () => {
    setPageNumber(pageNum => pageNum + 1);
  };
  const isPagesAvailable = numPages && numPages !== 1;
  const isFirstPage = pageNumber === 1;
  const isLastPage = pageNumber === numPages;
  return /*#__PURE__*/React.createElement("div", {
    className: classes.customPdfViewer
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.pdfContainer
  }, /*#__PURE__*/React.createElement(Document, {
    file: file,
    onLoadSuccess: onDocumentLoad,
    loading: /*#__PURE__*/React.createElement(Loading, null)
  }, /*#__PURE__*/React.createElement(Page, {
    pageNumber: pageNumber,
    renderAnnotationLayer: false,
    className: classes.page
  }))), isPagesAvailable && /*#__PURE__*/React.createElement("div", {
    className: classes.pagination
  }, /*#__PURE__*/React.createElement("img", {
    onClick: goPrev,
    className: classnames(isFirstPage && classes.disabledBtn),
    src: isFirstPage ? ChevronLeftDisabled : ChevronLeft,
    alt: "left"
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.pageNumber
  }, "Page ", pageNumber), /*#__PURE__*/React.createElement("img", {
    onClick: goNext,
    className: classnames(isLastPage && classes.disabledBtn),
    src: isLastPage ? ChevronRightDisabled : ChevronRight,
    alt: "right"
  })));
};
export default CustomPdfViewer;